module.exports = __webpack_public_path__ + "assets/40e9d99a54919c127354f12a01c9a9aa.svg";